import { getLoadablePage } from 'site-modules/shared/components/loadable-page/loadable-page';

export const oemShowroomRoutes = [
  {
    /**
     * Route for "OEM Showroom page
     * https://www.edmunds.com/oem-showroom/
     */
    path: '/oem-showroom',
    exact: true,
    page: getLoadablePage(
      () => import(/* webpackChunkName: "oem-showroom" */ '../pages/oem-showroom/oem-showroom-definition')
    ),
    chunkName: 'oem-showroom',
    enableLooseEtag: true,
  },
];
